import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import TypographyLayout from '../../components/typography-layout';
import Lorem from '../../components/lorem.mdx';
export const _frontmatter = {
  "title": "@theme-ui/typography"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = TypographyLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "theme-uitypography"
    }}>{`@theme-ui/typography`}</h1>
    <p>{`This page uses themes from Typography.js to populate the `}<inlineCode parentName="p">{`theme`}</inlineCode>{` object.
Select a theme from the controls above to view a live demo of each one.`}</p>
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`npm i @theme-ui/typography
`}</code></pre>
    <p>{`Use the `}<inlineCode parentName="p">{`toTheme`}</inlineCode>{` function to create a base `}<inlineCode parentName="p">{`theme`}</inlineCode>{` object based on Typography.js options or a preset Typography.js theme.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import React from 'react'
import { ThemeProvider } from 'theme-ui'
import { toTheme } from '@theme-ui/typography'
import wp2016 from 'typography-theme-wordpress-2016'

const theme = toTheme(wp2016)

export default props => (
  <ThemeProvider theme={theme}>{props.children}</ThemeProvider>
)
`}</code></pre>
    <h2 {...{
      "id": "extending-the-typographyjs-theme"
    }}>{`Extending the Typography.js theme`}</h2>
    <p>{`Use a deep merge utility, like the `}<inlineCode parentName="p">{`deepmerge`}</inlineCode>{` package, to extend or override the returned theme object.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { toTheme } from '@theme-ui/typography'
import wp2016 from 'typography-theme-wordpress-2016'
import merge from 'deepmerge'

const theme = merge(toTheme(wp2016), {
  colors: {
    text: '#000',
    background: '#fff',
    primary: '#07c',
  },
})
`}</code></pre>
    <p><em parentName="p">{`Demo content below`}</em></p>
    <hr></hr>
    <Lorem mdxType="Lorem" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      